export default "__VITE_ASSET__CPJhEuJK__"